import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataResponse } from '../../../../core/models/data-response';
import { ConfigService } from '../../../../core/services/config/config.service';
import { UtilityService } from '../../../../core/services/utility/utility.service';
import { PatientSurgicalHistory } from '../../models/patient-surgical-history';

@Injectable({
  providedIn: 'root',
})
export class PatientSurgicalHistoriesService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  patientSurgicalHistoryEndpoint = `${this.config.patientApiUrl}/v1/PatientPortal/PatientSurgeries`;

  postPatientSurgicalHistories(
    patientId: number,
    pageNumber: number | undefined,
    pageSize: number | undefined
  ): Observable<DataResponse<PatientSurgicalHistory[]>> {
    const searchParams = {
      pageNumber,
      pageSize,
    };
    return this.utilityService.postRequest<DataResponse<PatientSurgicalHistory[]>>(
      `${this.patientSurgicalHistoryEndpoint}?patientId=${patientId}`,
      searchParams,
      { rawResponse: true, applyDefaultTimeout: true }
    );
  }

  getAllPatientSurgicalHistoriesByPatientId(patientId: number): Observable<PatientSurgicalHistory[]> {
    const url = `${this.patientSurgicalHistoryEndpoint}?patientId=${patientId}`;
    return this.utilityService.getRequest<PatientSurgicalHistory[]>(url);
  }

  postPrintEvent(patientId: number, ids: number[]): Observable<void> {
    const url = `${this.patientSurgicalHistoryEndpoint}/PrintEvent?patientId=${patientId}`;
    return this.utilityService.postRequest<void>(url, { ids }, { skipGlobalError: true });
  }
}
